import CMS from 'decap-cms-app';

CMS.init({
  config: {
    backend: {
      name: 'git-gateway',
    },
  },
});
